import { NavigationEndpointConfig, NavigationEndpointOrder } from './constants';
import { NavigationEndpoint } from './types';

const TEXT_GROUP_ENDPOINTS: NavigationEndpoint[] = [
  NavigationEndpoint.social,
  NavigationEndpoint.blog,
  NavigationEndpoint.email
];

export const getNavItems = ({
  broadcastId,
  eventId,
  useTextGrouping = false
}: {
  broadcastId: string;
  eventId: string;
  useTextGrouping?: boolean;
}) => {
  return Object.entries(NavigationEndpointConfig)
    .filter(([endpoint]) =>
      useTextGrouping
        ? !TEXT_GROUP_ENDPOINTS.includes(endpoint as NavigationEndpoint)
        : endpoint !== NavigationEndpoint.text
    )
    .sort(
      ([e1], [e2]) =>
        NavigationEndpointOrder.indexOf(e1 as NavigationEndpoint) -
        NavigationEndpointOrder.indexOf(e2 as NavigationEndpoint)
    )
    .map(([endpoint, config]) => ({
      ...config,
      href: `/${eventId}/${broadcastId}/${endpoint}`
    }));
};
